<h2 class="portal-text" [style.color]="style()?.titleColor">
  {{ model().useTranslation ? (model().title | translate) : model().title }}
</h2>

@for (el of model().elementList; track $index) {
  <div class="panel list-group">
    <portal-list-element
      class="gast-bottom-border"
      [style.border-color]="style()?.borderBottomColor"
      [id]="id + $index"
      [label]="el.label"
      [content]="el.content"
      [useTranslation]="model().useTranslation"
      [style]="style()">
    </portal-list-element>
  </div>
}
